export const scl90CardData = [
    {
      title: "Somatización",
      tooltipText:
        "Somatización (SOM), refleja sintomatología psicosomática aunque también puede reflejar una patología médica subyacente.",
      dataKey: "percSom",
    },
    {
      title: "Obsesión compulsión",
      tooltipText:
        "Obsesión compulsión (OBS), refleja conductas, pensamientos e impulsos absurdos e indeseados, que generan una angustia intensa y que son difíciles de resistir, evitar o eliminar, además de otras vivencias y fenómenos cognitivos característicos de los trastornos y personalidades obsesivas.",
      dataKey: "percObs",
    },
    {
      title: "Sensibilidad interpersonal",
      tooltipText:
        "Sensibilidad interpersonal (INT), refleja sentimientos de timidez y vergüenza, tendencia a sentirse inferior a los demás, hipersensibilidad a las opiniones y actitudes ajenas y, en general, incomodidad e inhibición en las relaciones interpersonales.",
      dataKey: "percSi",
    },
    {
      title: "Depresión",
      tooltipText:
        "Depresión (DEP), refleja sentimientos de disforia, desánimo, anhedonia, desesperanza, impotencia y falta de energía, así como ideas autodestructivas y otras manifestaciones cognitivas y somáticas características de los estados depresivos.",
      dataKey: "percDep",
    },
    {
      title: "Ansiedad",
      tooltipText:
        "Ansiedad (ANS), refleja manifestaciones clínicas de la ansiedad, tanto generalizada como aguda (pánico), así como tensión emocional y sus manifestaciones psicosomáticas.",
      dataKey: "percAns",
    },
    {
      title: "Hostilidad",
      tooltipText:
        "Hostilidad (HOS), refleja pensamientos, sentimientos y conductas propios de estados de agresividad, ira, irritabilidad, rabia y resentimiento.",
      dataKey: "percHos",
    },
    {
      title: "Ansiedad fóbica",
      tooltipText:
        "Ansiedad fóbica (FOB), refleja el miedo persistente, irracional y desproporcionado a un animal o persona, lugar, objeto o situación, generalmente complicado por conductas evitativas o de huida.",
      dataKey: "percFob",
    },
    {
      title: "Ideación paranoide",
      tooltipText:
        "Ideación paranoide (PAR), refleja distintos aspectos de la conducta paranoide, como suspicacia, centralismo autorreferencial e ideación delirante, hostilidad, grandiosidad, miedo a la pérdida de autonomía y necesidad de control.",
      dataKey: "percPar",
    },
    {
      title: "Psicoticismo",
      tooltipText:
        "Psicoticismo (PSI), refleja sentimientos de alienación social.",
      dataKey: "percPsic",
    },
    {
      title: "Indice Global de Gravedad",
      tooltipText:
        "Indice Global de Gravedad (GSI), refleja la intensidad del sufrimiento psíquico y psicosomático global.",
      dataKey: "percGsi",
    },
    {
      title: "Total de Síntomas Positivos",
      tooltipText:
        "Total de Síntomas Positivos (PST), refleja el número total de síntomas presentes.",
      dataKey: "percPst",
    },
    {
      title: "Distrés de Síntomas Positivos",
      tooltipText:
        "Distrés de Síntomas Positivos (PSDI), refleja la intensidad de los síntomas.",
      dataKey: "percPsdi",
    },
    {
      title: "Síntomas misceláneos",
      tooltipText:
        "Síntomas misceláneos (ADI), refleja la gravedad de la depresión.",
      dataKey: "totalDimenAdi",
    },
  ];
  